import Vue from 'vue'
import router from '@/router'
import store from '@/store/index'

export const cloneObject = (v) => {
  return Vue.util.extend({}, v)
}
export const extendObject = (m, v) => {
  return Vue.util.extend(m, v)
}
export const extendNewObject = (m, v) => {
  return Vue.util.extend({}, Vue.util.extend(m, v))
}
export const copyObject = (m, v) => {
  Object.keys(m).forEach((key) => {
    if (v.hasOwnProperty(key)) {
      if (m[key] instanceof Array) {
        m[key].length = 0
        v[key].forEach((value) => {
          m[key].push(value)
        })
      } else {
        m[key] = v[key]
      }
    }
  })
}
export const dict2value = (ary, key) => {
  const fil = ary.filter(r => r.value === key)
  return fil.length > 0 ? fil[0].text : 'none'
}

// * 一括Validation処理
// * this.$refs を指定する
export const refValidate = (refs, form) => {
  // ref設定したFieldを一括validateする
  let results = Object.keys(refs).map((k) => {
    return refs[k].validate(form[k])
  })
  return (results.filter(e => e === false).length === 0)
}

// graphql authエラーの確認
export const checkAuth = (error) => {
  console.log('checkAuth', error.graphQLErrors)
  let flg = false
  error.graphQLErrors.forEach((err) => {
    if (err.message.indexOf('flask_graphql_auth') > 0) flg = true
  })
  if (flg) {
    console.log('auth error')
    store.commit('auth/destroy')
    try {
      router.go(router.currentRoute)
    } catch (e) {
      // エラー回避
    }
    return false
  }
  return true
}

// API URL を取得
export const getAPIURL = () => {
  let hostname = window.location.protocol + '//' + window.location.host
  // stagingの www と本番の i.を api.に置換する 開発中はlocalhostなので変化なし
  let apiname = hostname.replace('//management.', '//api.').replace('//mng.', '//api.').replace('//testmng.', '//testapi.')
  return apiname
}

// コラムイメージのURLを取得
export const getImageURL = () => {
  let hostname = window.location.protocol + '//' + window.location.host
  let imgname = hostname.replace('//management.', '//api.').replace('//mng.', '//api.').replace('//testmng.', '//testapi.')
  return imgname
}



// WEBPACK FOOTER //
// ./src/lib/utils.js